import { render } from "./ResultSummary.vue?vue&type=template&id=33b5fd3a"
import script from "./ResultSummary.vue?vue&type=script&lang=js"
export * from "./ResultSummary.vue?vue&type=script&lang=js"

import "./ResultSummary.vue?vue&type=style&index=0&id=33b5fd3a&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__